import React, { Component } from 'react';
import {withRouter} from 'react-router-dom';
import { store } from '../../redux/store';

import './index.css';

import ThreadItem from '../../threaditem';

import SecureAxiosClient from '../../auth/secure_axios';
import getConfig from '../../config';
import * as ChatActions from '../../redux/actions/chat';

class PopularThreadsByUserCount extends Component {

    constructor(props) {
		super(props);

		this.state = { threads: [] };	
	}

	componentDidMount() {
		this.getAllThreads();

    store.dispatch(ChatActions.setThemeImage({
      theme_image: null
    }));
	}

	getAllThreads() {
		let config = getConfig();
		//TODO: Update URL later
		let getThreadUrl = `${config.luigi.domain}${config.luigi.services.thread_popular_by_user_count}`;
		console.log("Get Thread url:", getThreadUrl);
		new SecureAxiosClient().get(
			getThreadUrl,
			(responseCode, responseData) => {
				console.log("List of thread", responseData);
				this.setState({ threads: responseData });
			}
		)
	}
	

	render() {
		const threadLists = this.state.threads && this.state.threads
    .filter(thread => thread && !thread.disabled)
    .map(thread => (
			<ThreadItem key={thread.id} thread={thread} />
		));
		return (
			<div className='page'>
                <h1>Popular Threads By User Count</h1>
				<div className='thread-list'>
					<ul>
						{threadLists}
					</ul>
				</div>
			</div>
		);
	}
}

export default withRouter(PopularThreadsByUserCount);
